<template>
  <BaseTemplate app-name="Logs do Portal" page-title="">
    <template #content>
      <!-- Verificação de permissão -->
      <div v-if="!temPermissao" class="w-full py-6 px-4 md:px-8">
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
          <div class="mb-4">
            <svg class="mx-auto h-16 w-16 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Acesso Negado</h2>
          <p class="text-gray-600 dark:text-gray-300 mb-6">
            Você não tem permissão para acessar esta página. Apenas superadmin e desenvolvedor podem visualizar os logs.
          </p>
          <button @click="voltar" class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg">
            Voltar
          </button>
        </div>
      </div>

      <div v-else class="w-full py-6 px-4 md:px-8">
        <!-- Botão Voltar -->
        <button @click="voltar"
          class="hidden md:inline-flex mb-5 items-center gap-2 bg-blue-500 dark:bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors dark:hover:bg-blue-700">
          <SquareArrowLeft class="w-5 h-5" />
          <span>Voltar</span>
        </button>

        <!-- Cabeçalho -->
        <div class="flex flex-col sm:flex-row justify-between items-center mb-6">
          <h1 class="flex items-center gap-2 text-2xl font-bold text-gray-900 dark:text-white">
            <FileText class="w-6 h-6 text-blue-500" />
            Logs do Portal
          </h1>
          <button @click="toggleGraficos"
            class="mt-4 sm:mt-0 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg shadow">
            <BarChart3 class="w-5 h-5" />
            {{ mostrarGraficos ? 'Ocultar' : 'Mostrar' }} Gráficos
          </button>
        </div>

        <!-- Estatísticas Gerais (sempre visíveis) -->
        <!-- Aba Geral: Todos os cards -->
        <div v-if="abaAtiva === 'geral'" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-3 mb-6">
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <Activity class="w-5 h-5 text-blue-500 dark:text-blue-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Total de Acessos</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <FileText class="w-5 h-5 text-green-500 dark:text-green-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos aos Preparos</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_preparos }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <LogIn class="w-5 h-5 text-orange-500 dark:text-orange-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos aos Resultados</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_resultados }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <Activity class="w-5 h-5 text-purple-500 dark:text-purple-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos ao Place</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_telelaudo }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <Activity class="w-5 h-5 text-indigo-500 dark:text-indigo-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos ao WorksLightWeb</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_portalweb || 0 }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <LogIn class="w-5 h-5 text-red-500 dark:text-red-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Tentativas de Login (Paciente)</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.tentativas_login }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <LogIn class="w-5 h-5 text-emerald-500 dark:text-emerald-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Logins com Sucesso (Paciente)</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.logins_sucesso }}</p>
          </div>
        </div>
        
        <!-- Aba Place: Apenas Place -->
        <div v-if="abaAtiva === 'telelaudo'" class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mb-6">
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <Activity class="w-5 h-5 text-purple-500 dark:text-purple-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos ao Place</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_telelaudo || estatisticas.total }}</p>
          </div>
        </div>
        
        <!-- Aba WorksLightWeb: Apenas WorksLightWeb -->
        <div v-if="abaAtiva === 'portalweb'" class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mb-6">
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <Activity class="w-5 h-5 text-indigo-500 dark:text-indigo-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos ao WorksLightWeb</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_portalweb || estatisticas.total }}</p>
          </div>
        </div>
        
        <!-- Card de Unidade Filtrada (Place e WorksLightWeb) -->
        <transition name="slide-up">
          <div v-if="!mostrarGraficos && filtros.unidade && (abaAtiva === 'telelaudo' || abaAtiva === 'portalweb')" 
               class="mb-6 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between">
              <div class="flex items-center gap-4">
                <div class="w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600 dark:text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Unidade Selecionada</p>
                  <p class="text-xl font-bold text-gray-900 dark:text-white">{{ filtros.unidade }}</p>
                </div>
              </div>
              <div class="text-right">
                <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Total de Acessos</p>
                <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total || 0 }}</p>
              </div>
            </div>
          </div>
        </transition>
        
        <!-- Aba Preparos: Apenas Preparos -->
        <div v-if="abaAtiva === 'preparos'" class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-3 mb-6">
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <FileText class="w-5 h-5 text-green-500 dark:text-green-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos aos Preparos</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_preparos || estatisticas.total }}</p>
          </div>
        </div>
        
        <!-- Aba Resultados: Resultados, Tentativas e Sucessos -->
        <div v-if="abaAtiva === 'resultados'" class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-3 mb-6">
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <LogIn class="w-5 h-5 text-orange-500 dark:text-orange-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Acessos aos Resultados</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.total_resultados || estatisticas.total }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <LogIn class="w-5 h-5 text-red-500 dark:text-red-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Tentativas de Login</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.tentativas_login }}</p>
          </div>
          <div class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center justify-between mb-1">
              <LogIn class="w-5 h-5 text-emerald-500 dark:text-emerald-400" />
            </div>
            <p class="text-xs text-gray-600 dark:text-gray-400 mb-1">Logins com Sucesso</p>
            <p class="text-xl font-bold text-gray-900 dark:text-white">{{ estatisticas.logins_sucesso }}</p>
          </div>
        </div>
            
        <!-- Gráficos -->
        <transition name="slide-down">
          <div v-if="mostrarGraficos" class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-6 mb-6">
            <h2 class="text-xl font-bold text-gray-900 dark:text-white mb-4">Estatísticas e Gráficos</h2>
            
            <!-- Tabs principais: Gráficos e Relatórios -->
            <div class="mb-6 border-b border-gray-200 dark:border-gray-700">
              <nav class="-mb-px flex space-x-8">
                <button
                  @click="tipoGrafico = 'graficos'"
                  :class="[
                    'py-4 px-1 border-b-2 font-medium text-sm transition-colors',
                    tipoGrafico === 'graficos'
                      ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                  ]">
                  Gráficos
                </button>
                <button
                  @click="tipoGrafico = 'relatorios'"
                  :class="[
                    'py-4 px-1 border-b-2 font-medium text-sm transition-colors',
                    tipoGrafico === 'relatorios'
                      ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                  ]">
                  Relatórios
                </button>
              </nav>
            </div>
            
            <!-- Filtros para o gráfico -->
            <div v-if="tipoGrafico === 'graficos'" class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Início</label>
                <input v-model="filtrosGrafico.data_inicio" type="date"
                  class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Fim</label>
                <input v-model="filtrosGrafico.data_fim" type="date"
                  class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Acesso</label>
                <select v-model="filtrosGrafico.tipo_acesso"
                  class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                  <option value="">Todos</option>
                  <option value="preparos">Preparos</option>
                  <option value="resultados">Resultados</option>
                  <option value="telelaudo">Place</option>
                  <option value="portalweb">WorksLightWeb</option>
                </select>
              </div>
              <div class="flex items-end">
                <button @click="aplicarFiltrosGrafico"
                  class="w-full bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg">
                  Aplicar
                </button>
              </div>
            </div>


            <!-- Grid com todos os gráficos -->
            <div v-if="tipoGrafico === 'graficos'" class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <!-- Gráfico de Linha -->
              <div class="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 text-center">Tendência Mensal</h3>
                <div class="h-80">
                  <canvas ref="chartLinha"></canvas>
                </div>
              </div>
              
              <!-- Gráfico Rosquinha -->
              <div class="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 text-center">Distribuição por Tipo</h3>
                <div class="h-80">
                  <canvas ref="chartRosquinha"></canvas>
                </div>
              </div>
              
              <!-- Gráfico de Barras -->
              <div class="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 text-center">Tentativas vs Sucessos</h3>
                <div class="h-80">
                  <canvas ref="chartBarras"></canvas>
                </div>
              </div>
              
              <!-- Gráfico Pizza -->
              <div class="bg-gray-50 dark:bg-gray-700/30 rounded-lg p-4">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4 text-center">Distribuição Geral</h3>
                <div class="h-80">
                  <canvas ref="chartPizza"></canvas>
                </div>
              </div>
            </div>
            
            <!-- Aba de Relatórios -->
            <div v-if="tipoGrafico === 'relatorios'" class="space-y-6">
              <div class="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-6">
                <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Gerar Relatório</h3>
                
                <!-- Filtros do Relatório -->
                <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Início</label>
                    <input v-model="filtrosRelatorio.data_inicio" type="date"
                      class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Fim</label>
                    <input v-model="filtrosRelatorio.data_fim" type="date"
                      class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Relatório</label>
                    <select v-model="filtrosRelatorio.tipo_relatorio"
                      class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                      <option value="geral">Geral</option>
                      <option value="por_tipo_acesso">Por Tipo de Acesso</option>
                      <option value="por_tentativa">Por Tentativa de Login</option>
                      <option value="por_login_sucesso">Por Login com Sucesso</option>
                      <option value="por_place">Por Place</option>
                      <option value="por_unidade_place">Por Unidade (Place) com Quantidade</option>
                      <option value="por_workslightweb">Por WorksLightWeb</option>
                      <option value="por_preparos">Por Preparos</option>
                      <option value="por_resultados">Por Resultados</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Orientação do PDF</label>
                    <select v-model="filtrosRelatorio.orientacao"
                      class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                      <option value="l">Horizontal (Paisagem)</option>
                      <option value="p">Vertical (Retrato)</option>
                      
                    </select>
                  </div>
                </div>
                
                <!-- Filtros adicionais para Place e WorksLightWeb -->
                <div v-if="filtrosRelatorio.tipo_relatorio === 'por_unidade_place' || filtrosRelatorio.tipo_relatorio === 'por_place'" 
                     class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidade (Place)</label>
                    <select v-model="filtrosRelatorio.unidade_place"
                      class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                      <option value="">Todas as Unidades</option>
                      <option v-for="unidade in unidadesDisponiveisRelatorio" :key="unidade" :value="unidade">{{ unidade }}</option>
                    </select>
                  </div>
                </div>
                
                <div v-if="filtrosRelatorio.tipo_relatorio === 'por_workslightweb'" 
                     class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidade (WorksLightWeb)</label>
                    <select v-model="filtrosRelatorio.unidade_workslightweb"
                      class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                      <option value="">Todas as Unidades</option>
                      <option v-for="unidade in unidadesDisponiveisRelatorio" :key="unidade" :value="unidade">{{ unidade }}</option>
                    </select>
                  </div>
                </div>
                
                <!-- Aviso de filtros alterados -->
                <div v-if="filtrosAlterados && dadosRelatorio.length > 0" 
                     class="mb-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg p-4 flex items-start gap-3">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-yellow-600 dark:text-yellow-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  <div class="flex-1">
                    <p class="text-sm font-medium text-yellow-800 dark:text-yellow-200">
                      Os filtros foram alterados. Clique em "Gerar Relatório" novamente para atualizar os dados.
                    </p>
                  </div>
                </div>
                
                <!-- Botão Gerar Relatório -->
                <div class="flex gap-3">
                  <button @click="gerarRelatorio"
                    :disabled="gerandoRelatorio"
                    class="flex items-center gap-2 bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white px-6 py-2 rounded-lg font-medium transition-colors">
                    <svg v-if="!gerandoRelatorio" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    <div v-else class="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    {{ gerandoRelatorio ? 'Gerando...' : 'Gerar Relatório' }}
                  </button>
                  <button v-if="dadosRelatorio.length > 0" @click="downloadCSV"
                    class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-medium transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Baixar CSV
                  </button>
                  <button v-if="dadosRelatorio.length > 0" @click="gerarPDFRelatorio" :disabled="gerandoRelatorio"
                    class="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg font-medium transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Baixar PDF
                  </button>
                </div>
              </div>
              
              <!-- Visualização dos Dados do Relatório -->
              <div v-if="mostrarVisualizacao && dadosRelatorio.length > 0" class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm overflow-x-auto">
                <div class="p-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
                  <h4 class="text-lg font-semibold text-gray-900 dark:text-white">Dados do Relatório</h4>
                  <button @click="mostrarVisualizacao = false" class="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <div class="overflow-x-auto max-h-96">
                  <table class="w-full text-sm">
                    <thead class="bg-gray-50 dark:bg-gray-700 sticky top-0">
                      <tr>
                        <th v-for="coluna in colunasRelatorio" :key="coluna" 
                            class="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider">
                          {{ coluna }}
                        </th>
                      </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
                      <tr v-for="(linha, index) in dadosRelatorio" :key="index" 
                          class="hover:bg-gray-50 dark:hover:bg-gray-700">
                        <td v-for="coluna in colunasRelatorio" :key="coluna" 
                            class="px-4 py-3 whitespace-nowrap text-gray-900 dark:text-gray-100">
                          {{ linha[coluna] || '-' }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="p-4 border-t border-gray-200 dark:border-gray-700 text-sm text-gray-600 dark:text-gray-400">
                  Total de registros: {{ dadosRelatorio.length }}
                </div>
              </div>
            </div>
          </div>
        </transition>

        <!-- Botão Filtros -->
        <div v-if="!mostrarGraficos && tipoGrafico !== 'relatorios'" class="mb-4">
          <button @click="mostrarFiltros = !mostrarFiltros"
            class="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg shadow transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
            {{ mostrarFiltros ? 'Ocultar' : 'Mostrar' }} Filtros
          </button>
        </div>

        <!-- Filtros -->
        <transition name="slide-down">
          <div v-if="!mostrarGraficos && mostrarFiltros && tipoGrafico !== 'relatorios'" class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4 mb-6">
          <div v-if="abaAtiva === 'telelaudo' || abaAtiva === 'portalweb'" class="grid grid-cols-1 md:grid-cols-5 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Início</label>
              <input v-model="filtros.data_inicio" type="date"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Fim</label>
              <input v-model="filtros.data_fim" type="date"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Unidade</label>
              <select v-model="filtros.unidade"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                <option value="">Todas as Unidades</option>
                <option v-for="unidade in unidadesDisponiveis" :key="unidade" :value="unidade">{{ unidade }}</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Acesso</label>
              <select v-model="filtros.tipo_acesso"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                <option value="">Todos</option>
                <option v-if="abaAtiva === 'telelaudo'" value="telelaudo">Place</option>
                <option v-if="abaAtiva === 'portalweb'" value="portalweb">WorksLightWeb</option>
              </select>
            </div>
            <div class="flex items-end">
              <button @click="aplicarFiltros"
                class="w-full bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg">
                Aplicar Filtros
              </button>
            </div>
          </div>
          <div v-else class="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Início</label>
              <input v-model="filtros.data_inicio" type="date"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Data Fim</label>
              <input v-model="filtros.data_fim" type="date"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500" />
            </div>
            <div v-if="abaAtiva === 'geral'">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Acesso</label>
              <select v-model="filtros.tipo_acesso"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                <option value="">Todos</option>
                <option value="preparos">Preparos</option>
                <option value="resultados">Resultados</option>
                <option value="telelaudo">Place</option>
                <option value="portalweb">WorksLightWeb</option>
              </select>
            </div>
            <div v-if="abaAtiva === 'preparos'">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Tipo de Acesso</label>
              <select v-model="filtros.tipo_acesso"
                class="w-full border rounded-lg px-3 py-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white focus:ring-2 focus:ring-blue-500">
                <option value="">Todos</option>
                <option value="preparos">Preparos</option>
              </select>
            </div>
            <div class="flex items-end">
              <button @click="aplicarFiltros"
                class="w-full bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg">
                Aplicar Filtros
              </button>
            </div>
          </div>
          </div>
        </transition>

        <!-- Abas -->
        <div class="mb-6 border-b border-gray-200 dark:border-gray-700">
          <nav class="flex space-x-8 overflow-x-auto">
            <button @click="abaAtiva = 'geral'"
              :class="abaAtiva === 'geral' ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'"
              class="py-4 px-1 text-sm font-medium transition-colors whitespace-nowrap">
              Geral
            </button>
            <button @click="abaAtiva = 'resultados'"
              :class="abaAtiva === 'resultados' ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'"
              class="py-4 px-1 text-sm font-medium transition-colors whitespace-nowrap">
              Portal do Paciente
            </button>
            <button @click="abaAtiva = 'telelaudo'"
              :class="abaAtiva === 'telelaudo' ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'"
              class="py-4 px-1 text-sm font-medium transition-colors whitespace-nowrap">
              Place
            </button>
            <button @click="abaAtiva = 'portalweb'"
              :class="abaAtiva === 'portalweb' ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'"
              class="py-4 px-1 text-sm font-medium transition-colors whitespace-nowrap">
              WorksLightWeb
            </button>
            <button @click="abaAtiva = 'preparos'"
              :class="abaAtiva === 'preparos' ? 'border-b-2 border-blue-500 text-blue-600 dark:text-blue-400' : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-300'"
              class="py-4 px-1 text-sm font-medium transition-colors whitespace-nowrap">
              Preparos
            </button>

          </nav>
        </div>

        <!-- Mensagem de erro -->
        <p v-if="error && !mostrarGraficos" class="text-red-500 text-center mb-4">{{ error }}</p>

        <!-- Loading -->
        <div v-if="isLoading" class="text-center py-8">
          <div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          <p class="mt-2 text-gray-600 dark:text-gray-400">Carregando logs...</p>
        </div>

        <!-- Tabela desktop -->
        <div v-if="!isLoading && !mostrarGraficos"
          class="hidden sm:block bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm overflow-x-auto dark:text-white text-gray-800">
          <table class="w-full">
            <thead class="bg-blue-500 dark:bg-blue-600 text-white dark:text-gray-300 text-sm uppercase tracking-wide rounded-t-lg">
              <tr>
                <th class="px-4 py-3 text-left">Data/Hora</th>
                <th v-if="abaAtiva === 'geral'" class="px-4 py-3 text-left">Tipo de Acesso</th>
                <th v-if="abaAtiva === 'resultados'" class="px-4 py-3 text-left">Login do Exame</th>
                <th v-if="abaAtiva === 'resultados'" class="px-4 py-3 text-left">Status do Login</th>
                <th v-if="abaAtiva === 'telelaudo' || abaAtiva === 'portalweb'" class="px-4 py-3 text-left">Unidade</th>
                <th class="px-4 py-3 text-left">IP</th>
                <th class="px-4 py-3 text-left">User Agent</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="acesso in acessos" :key="acesso.id"
                class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
                <td class="px-4 py-3">{{ formatarData(acesso.data_hora) }}</td>
                <td v-if="abaAtiva === 'geral'" class="px-4 py-3">
                  <span :class="acesso.tipo_acesso === 'preparos' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : acesso.tipo_acesso === 'telelaudo' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' : acesso.tipo_acesso === 'portalweb' ? 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-200' : 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200'"
                    class="px-2 py-1 rounded-full text-xs font-semibold">
                    {{ acesso.tipo_acesso_display }}
                  </span>
                </td>
                <td v-if="abaAtiva === 'resultados'" class="px-4 py-3">{{ acesso.login_exame || '-' }}</td>
                <td v-if="abaAtiva === 'resultados'" class="px-4 py-3">
                  <span v-if="acesso.status_login_display" 
                    :class="acesso.status_login === 'sucesso' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'"
                    class="px-2 py-1 rounded-full text-xs font-semibold">
                    {{ acesso.status_login_display }}
                  </span>
                  <span v-else class="text-gray-400 dark:text-gray-500">-</span>
                </td>
                <td v-if="abaAtiva === 'telelaudo' || abaAtiva === 'portalweb'" class="px-4 py-3">{{ acesso.unidade || '-' }}</td>
                <td class="px-4 py-3 font-mono text-sm">{{ acesso.ip_address || '-' }}</td>
                <td class="px-4 py-3 text-sm max-w-xs truncate" :title="acesso.user_agent">{{ acesso.user_agent || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Cards mobile -->
        <div v-if="!isLoading && !mostrarGraficos" class="sm:hidden space-y-4">
          <div v-for="acesso in acessos" :key="acesso.id"
            class="bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4">
            <div class="flex justify-between items-start mb-2">
              <span :class="acesso.tipo_acesso === 'preparos' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : acesso.tipo_acesso === 'telelaudo' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' : 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200'"
                class="px-2 py-1 rounded-full text-xs font-semibold">
                {{ acesso.tipo_acesso_display }}
              </span>
              <span class="text-xs text-gray-500 dark:text-gray-400">{{ formatarData(acesso.data_hora) }}</span>
            </div>
            <div class="space-y-1 text-sm">
              <p v-if="abaAtiva === 'geral'" class="text-gray-700 dark:text-gray-300">
                <span class="font-semibold">Tipo:</span>
                <span :class="acesso.tipo_acesso === 'preparos' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : acesso.tipo_acesso === 'telelaudo' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200' : 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200'"
                  class="ml-2 px-2 py-1 rounded-full text-xs font-semibold">
                  {{ acesso.tipo_acesso_display }}
                </span>
              </p>
              <p v-if="abaAtiva === 'resultados' && acesso.login_exame" class="text-gray-700 dark:text-gray-300">
                <span class="font-semibold">Login:</span> {{ acesso.login_exame }}
              </p>
              <p v-if="abaAtiva === 'resultados' && acesso.status_login_display" class="text-gray-700 dark:text-gray-300">
                <span class="font-semibold">Status:</span>
                <span :class="acesso.status_login === 'sucesso' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200' : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'"
                  class="ml-2 px-2 py-1 rounded-full text-xs font-semibold">
                  {{ acesso.status_login_display }}
                </span>
              </p>
              <p v-if="(abaAtiva === 'telelaudo' || abaAtiva === 'portalweb') && acesso.unidade" class="text-gray-700 dark:text-gray-300">
                <span class="font-semibold">Unidade:</span> {{ acesso.unidade }}
              </p>
              <p class="text-gray-700 dark:text-gray-300">
                <span class="font-semibold">IP:</span> <span class="font-mono">{{ acesso.ip_address || '-' }}</span>
              </p>
              <p class="text-gray-600 dark:text-gray-400 text-xs truncate" :title="acesso.user_agent">
                <span class="font-semibold">User Agent:</span> {{ acesso.user_agent || '-' }}
              </p>
            </div>
          </div>
        </div>

        <!-- Mensagem quando não há acessos -->
        <div v-if="!isLoading && !mostrarGraficos && acessos.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
          <p>Nenhum acesso encontrado para os filtros selecionados.</p>
        </div>

        <!-- Paginação -->
        <div v-if="!isLoading && !mostrarGraficos && pagination.total_pages > 1" class="flex flex-col sm:flex-row justify-between items-center gap-4 mt-6 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm p-4">
          <div class="text-sm text-gray-600 dark:text-gray-400">
            Mostrando {{ ((pagination.current_page - 1) * pagination.per_page) + 1 }} a 
            {{ Math.min(pagination.current_page * pagination.per_page, pagination.total) }} de 
            {{ pagination.total }} acessos
          </div>
          <div class="flex gap-2">
            <button 
              @click="irParaPagina(pagination.current_page - 1)"
              :disabled="!pagination.has_previous"
              class="px-4 py-2 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors">
              Anterior
            </button>
            <div class="flex gap-1">
              <span
                v-for="page in paginasVisiveis"
                :key="page"
              >
                <button
                  v-if="page !== '...'"
                  @click="irParaPagina(page)"
                  :class="[
                    'px-4 py-2 rounded-lg transition-colors',
                    page === pagination.current_page
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-gray-700 dark:text-gray-300'
                  ]">
                  {{ page }}
                </button>
                <span
                  v-else
                  class="px-4 py-2 text-gray-500 dark:text-gray-400"
                >
                  {{ page }}
                </span>
              </span>
            </div>
            <button 
              @click="irParaPagina(pagination.current_page + 1)"
              :disabled="!pagination.has_next"
              class="px-4 py-2 bg-blue-500 hover:bg-blue-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-lg transition-colors">
              Próxima
            </button>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>
</template>

<script setup>
import { ref, onMounted, computed, watch, nextTick } from 'vue';
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import apiClient from '@/services/authService';
import BaseTemplate from '../templates/BaseTemplate.vue';
import { SquareArrowLeft, FileText, BarChart3, Activity, LogIn } from 'lucide-vue-next';
import { Chart, registerables } from 'chart.js';
import jsPDF from 'jspdf';

Chart.register(...registerables);

const router = useRouter();
const userStore = useUserStore();
const userGroups = computed(() => userStore.grupos || []);

const temPermissao = computed(() => {
  return userGroups.value.includes('superadmin') || userGroups.value.includes('desenvolvedor');
});

const acessos = ref([]);
const pagination = ref({
  current_page: 1,
  per_page: 20,
  total: 0,
  total_pages: 1,
  has_next: false,
  has_previous: false
});
const estatisticas = ref({
  total: 0,
  total_preparos: 0,
  total_resultados: 0,
  total_telelaudo: 0,
  total_portalweb: 0,
  tentativas_login: 0,
  logins_sucesso: 0
});
const isLoading = ref(false);
const error = ref(null);
const mostrarGraficos = ref(false);
const mostrarFiltros = ref(false);
const tipoGrafico = ref('graficos');
const chartLinha = ref(null);
const chartRosquinha = ref(null);
const chartBarras = ref(null);
const chartPizza = ref(null);
let chartInstanceLinha = null;
let chartInstanceRosquinha = null;
let chartInstanceBarras = null;
let chartInstancePizza = null;

const abaAtiva = ref('geral'); // 'geral', 'telelaudo', 'portalweb', 'preparos', 'resultados'
const unidadesDisponiveis = ref([]);
const unidadesDisponiveisRelatorio = ref([]);

// Variáveis para relatórios
const filtrosRelatorio = ref({
  data_inicio: '',
  data_fim: '',
  tipo_relatorio: 'geral',
  unidade_place: '',
  unidade_workslightweb: '',
  orientacao: 'l' // 'p' para vertical (portrait), 'l' para horizontal (landscape)
});
const gerandoRelatorio = ref(false);
const dadosRelatorio = ref([]);
const colunasRelatorio = ref([]);
const totalGeralRelatorio = ref(null);
const totalPorUnidadeRelatorio = ref([]);
const mostrarVisualizacao = ref(false);
const filtrosAlterados = ref(false);

const filtros = ref({
  data_inicio: '',
  data_fim: '',
  tipo_acesso: '',
  unidade: ''
});

const filtrosGrafico = ref({
  data_inicio: '',
  data_fim: '',
  tipo_acesso: ''
});

const voltar = () => {
  router.push('/config');
};

const carregarUnidades = async () => {
  try {
    const tipoAcesso = abaAtiva.value === 'telelaudo' ? 'telelaudo' : abaAtiva.value === 'portalweb' ? 'portalweb' : null;
    const params = tipoAcesso ? `?tipo_acesso=${tipoAcesso}` : '';
    const response = await apiClient.get(`/api/v1/portal-acessos/admin/unidades${params}`);
    unidadesDisponiveis.value = response.data.unidades || [];
  } catch (err) {
    console.error('Erro ao carregar unidades:', err);
    unidadesDisponiveis.value = [];
  }
};

const carregarUnidadesRelatorio = async () => {
  try {
    // Carregar unidades de Place
    const responsePlace = await apiClient.get('/api/v1/portal-acessos/admin/unidades?tipo_acesso=telelaudo');
    const unidadesPlace = responsePlace.data.unidades || [];
    
    // Carregar unidades de WorksLightWeb
    const responseWorks = await apiClient.get('/api/v1/portal-acessos/admin/unidades?tipo_acesso=portalweb');
    const unidadesWorks = responseWorks.data.unidades || [];
    
    // Combinar e remover duplicatas
    const todasUnidades = [...new Set([...unidadesPlace, ...unidadesWorks])].sort();
    unidadesDisponiveisRelatorio.value = todasUnidades;
  } catch (err) {
    console.error('Erro ao carregar unidades para relatório:', err);
    unidadesDisponiveisRelatorio.value = [];
  }
};

const formatarData = (dataISO) => {
  if (!dataISO) return '-';
  const data = new Date(dataISO);
  return data.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const carregarAcessos = async () => {
  isLoading.value = true;
  error.value = null;
  try {
    const params = new URLSearchParams();
    if (filtros.value.data_inicio) params.append('data_inicio', filtros.value.data_inicio);
    if (filtros.value.data_fim) params.append('data_fim', filtros.value.data_fim);
    
    // Aplicar filtro de tipo_acesso baseado na aba ativa
    if (abaAtiva.value === 'telelaudo') {
      params.append('tipo_acesso', 'telelaudo');
      if (filtros.value.unidade) params.append('unidade', filtros.value.unidade);
    } else if (abaAtiva.value === 'portalweb') {
      params.append('tipo_acesso', 'portalweb');
      if (filtros.value.unidade) params.append('unidade', filtros.value.unidade);
    } else if (abaAtiva.value === 'preparos') {
      params.append('tipo_acesso', 'preparos');
    } else if (abaAtiva.value === 'resultados') {
      params.append('tipo_acesso', 'resultados');
    } else if (filtros.value.tipo_acesso) {
      // Na aba geral, usar o filtro selecionado
      params.append('tipo_acesso', filtros.value.tipo_acesso);
    }
    
    params.append('page', pagination.value.current_page.toString());
    params.append('per_page', pagination.value.per_page.toString());

    const response = await apiClient.get(`/api/v1/portal-acessos/admin/?${params.toString()}`);
    acessos.value = response.data.data;
    pagination.value = response.data.pagination;
  } catch (err) {
    error.value = 'Erro ao carregar acessos.';
    console.error('Erro ao carregar acessos:', err);
    acessos.value = [];
  } finally {
    isLoading.value = false;
  }
};

const carregarEstatisticas = async () => {
  try {
    const params = new URLSearchParams();
    if (filtros.value.data_inicio) params.append('data_inicio', filtros.value.data_inicio);
    if (filtros.value.data_fim) params.append('data_fim', filtros.value.data_fim);
    
    // Aplicar filtro de tipo_acesso baseado na aba ativa
    if (abaAtiva.value === 'telelaudo') {
      params.append('tipo_acesso', 'telelaudo');
    } else if (abaAtiva.value === 'portalweb') {
      params.append('tipo_acesso', 'portalweb');
    } else if (abaAtiva.value === 'preparos') {
      params.append('tipo_acesso', 'preparos');
    } else if (abaAtiva.value === 'resultados') {
      params.append('tipo_acesso', 'resultados');
    } else if (filtros.value.tipo_acesso) {
      // Na aba geral, usar o filtro selecionado
      params.append('tipo_acesso', filtros.value.tipo_acesso);
    }

    const response = await apiClient.get(`/api/v1/portal-acessos/admin/total/?${params.toString()}`);
    estatisticas.value = response.data;
  } catch (err) {
    console.error('Erro ao carregar estatísticas:', err);
  }
};

const criarGraficoLinha = (dados) => {
  const labels = dados.map(item => {
    // Se tiver campo 'data', é diário; se tiver 'mes', é mensal
    if (item.data) {
      const data = new Date(item.data + 'T00:00:00'); // Adicionar hora para evitar problemas de timezone
      const dia = String(data.getDate()).padStart(2, '0');
      const mes = String(data.getMonth() + 1).padStart(2, '0');
      return `${dia}/${mes}`;
    } else if (item.mes) {
      const [ano, mes] = item.mes.split('-');
      const meses = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      return `${meses[parseInt(mes) - 1]}/${ano}`;
    }
    return '';
  });

  const isDark = document.documentElement.classList.contains('dark');
  const textColor = isDark ? '#f3f4f6' : '#1f2937';
  const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';

  // Definir datasets baseado na aba ativa
  let datasets = [];
  
  if (abaAtiva.value === 'geral') {
    datasets = [
      {
        label: 'Total de Acessos',
        data: dados.map(item => item.total_acessos || 0),
        borderColor: 'rgb(59, 130, 246)',
        backgroundColor: 'rgba(59, 130, 246, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(59, 130, 246)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Acessos aos Preparos',
        data: dados.map(item => item.acessos_preparos || 0),
        borderColor: 'rgb(34, 197, 94)',
        backgroundColor: 'rgba(34, 197, 94, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(34, 197, 94)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Acessos aos Resultados',
        data: dados.map(item => item.acessos_resultados || 0),
        borderColor: 'rgb(249, 115, 22)',
        backgroundColor: 'rgba(249, 115, 22, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(249, 115, 22)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Acessos ao Place',
        data: dados.map(item => item.acessos_telelaudo || 0),
        borderColor: 'rgb(168, 85, 247)',
        backgroundColor: 'rgba(168, 85, 247, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(168, 85, 247)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Acessos ao WorksLightWeb',
        data: dados.map(item => item.acessos_portalweb || 0),
        borderColor: 'rgb(99, 102, 241)',
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(99, 102, 241)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.4,
        fill: true
      }
    ];
  } else if (abaAtiva.value === 'preparos') {
    datasets = [
      {
        label: 'Acessos aos Preparos',
        data: dados.map(item => item.acessos_preparos || item.total_acessos || 0),
        borderColor: 'rgb(34, 197, 94)',
        backgroundColor: 'rgba(34, 197, 94, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(34, 197, 94)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
        fill: true
      }
    ];
  } else if (abaAtiva.value === 'resultados') {
    datasets = [
      {
        label: 'Acessos aos Resultados',
        data: dados.map(item => item.acessos_resultados || item.total_acessos || 0),
        borderColor: 'rgb(249, 115, 22)',
        backgroundColor: 'rgba(249, 115, 22, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(249, 115, 22)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Tentativas de Login',
        data: dados.map(item => item.tentativas_login || 0),
        borderColor: 'rgb(239, 68, 68)',
        backgroundColor: 'rgba(239, 68, 68, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(239, 68, 68)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.4,
        fill: true
      },
      {
        label: 'Logins com Sucesso',
        data: dados.map(item => item.logins_sucesso || 0),
        borderColor: 'rgb(16, 185, 129)',
        backgroundColor: 'rgba(16, 185, 129, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(16, 185, 129)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        tension: 0.4,
        fill: true
      }
    ];
  } else if (abaAtiva.value === 'telelaudo') {
    datasets = [
      {
        label: 'Acessos ao Place',
        data: dados.map(item => item.acessos_telelaudo || item.total_acessos || 0),
        borderColor: 'rgb(168, 85, 247)',
        backgroundColor: 'rgba(168, 85, 247, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(168, 85, 247)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
        fill: true
      }
    ];
  } else if (abaAtiva.value === 'portalweb') {
    datasets = [
      {
        label: 'Acessos ao WorksLightWeb',
        data: dados.map(item => item.acessos_portalweb || item.total_acessos || 0),
        borderColor: 'rgb(99, 102, 241)',
        backgroundColor: 'rgba(99, 102, 241, 0.15)',
        borderWidth: 3,
        pointBackgroundColor: 'rgb(99, 102, 241)',
        pointBorderColor: '#ffffff',
        pointBorderWidth: 2,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
        fill: true
      }
    ];
  }

  return {
    type: 'line',
    data: {
      labels: labels,
      datasets: datasets
    },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            intersect: false,
            mode: 'index'
          },
          animation: {
            duration: 1500,
            easing: 'easeInOutQuart'
          },
          plugins: {
            legend: {
              position: 'top',
              labels: {
                color: textColor,
                font: {
                  size: 13,
                  weight: '600',
                  family: "'Inter', sans-serif"
                },
                padding: 15,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            },
            title: {
              display: true,
              text: 'Estatísticas de Acessos Mensais',
              color: textColor,
              font: {
                size: 18,
                weight: 'bold',
                family: "'Inter', sans-serif"
              },
              padding: {
                top: 10,
                bottom: 20
              }
            },
            tooltip: {
              backgroundColor: isDark ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
              titleColor: textColor,
              bodyColor: textColor,
              borderColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
              borderWidth: 1,
              padding: 12,
              cornerRadius: 8,
              displayColors: true,
              titleFont: {
                size: 14,
                weight: 'bold'
              },
              bodyFont: {
                size: 13
              },
              boxPadding: 6,
              usePointStyle: true
            }
          },
          scales: {
            x: {
              grid: {
                color: gridColor,
                lineWidth: 1,
                drawBorder: true,
                borderColor: gridColor
              },
              ticks: {
                color: textColor,
                font: {
                  size: 12,
                  weight: '500'
                },
                padding: 10
              },
              title: {
                display: true,
                text: 'Período',
                color: textColor,
                font: {
                  size: 13,
                  weight: '600'
                },
                padding: {
                  top: 10,
                  bottom: 5
                }
              }
            },
            y: {
              beginAtZero: true,
              grid: {
                color: gridColor,
                lineWidth: 1,
                drawBorder: true,
                borderColor: gridColor
              },
              ticks: {
                color: textColor,
                font: {
                  size: 12,
                  weight: '500'
                },
                padding: 10,
                stepSize: 1,
                callback: function(value) {
                  return Number.isInteger(value) ? value : '';
                }
              },
              title: {
                display: true,
                text: 'Quantidade de Acessos',
                color: textColor,
                font: {
                  size: 13,
                  weight: '600'
                },
                padding: {
                  top: 5,
                  bottom: 10
                }
              }
            }
          }
        }
  };
};

const criarGraficoRosquinha = (estatisticas) => {
  const isDark = document.documentElement.classList.contains('dark');
  const textColor = isDark ? '#f3f4f6' : '#1f2937';
  
  let labels = [];
  let data = [];
  let backgroundColor = [];
  
  if (abaAtiva.value === 'geral') {
    labels = ['Preparos', 'Resultados', 'Place', 'WorksLightWeb'];
    data = [
      estatisticas.total_preparos,
      estatisticas.total_resultados,
      estatisticas.total_telelaudo,
      estatisticas.total_portalweb || 0
    ];
    backgroundColor = [
      'rgb(34, 197, 94)',
      'rgb(249, 115, 22)',
      'rgb(168, 85, 247)',
      'rgb(99, 102, 241)'
    ];
  } else if (abaAtiva.value === 'preparos') {
    labels = ['Preparos'];
    data = [estatisticas.total_preparos || estatisticas.total];
    backgroundColor = ['rgb(34, 197, 94)'];
  } else if (abaAtiva.value === 'resultados') {
    labels = ['Tentativas', 'Sucessos'];
    data = [
      estatisticas.tentativas_login,
      estatisticas.logins_sucesso
    ];
    backgroundColor = [
      'rgb(239, 68, 68)',
      'rgb(16, 185, 129)'
    ];
  } else if (abaAtiva.value === 'telelaudo') {
    labels = ['Place'];
    data = [estatisticas.total_telelaudo || estatisticas.total];
    backgroundColor = ['rgb(168, 85, 247)'];
  } else if (abaAtiva.value === 'portalweb') {
    labels = ['WorksLightWeb'];
    data = [estatisticas.total_portalweb || estatisticas.total];
    backgroundColor = ['rgb(99, 102, 241)'];
  }
  
  return {
    type: 'doughnut',
    data: {
      labels: labels,
      datasets: [{
        data: data,
        backgroundColor: backgroundColor,
        borderColor: isDark ? 'rgba(31, 41, 55, 1)' : 'rgba(255, 255, 255, 1)',
        borderWidth: 3,
        hoverOffset: 10
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            padding: 20,
            font: { size: 13, weight: '500' },
            color: textColor,
            usePointStyle: true
          }
        },
        tooltip: {
          backgroundColor: isDark ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
          titleColor: textColor,
          bodyColor: textColor,
          borderColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          borderWidth: 1,
          padding: 12,
          callbacks: {
            label: function(context) {
              const total = context.dataset.data.reduce((a, b) => a + b, 0);
              const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) : 0;
              return `${context.label}: ${context.parsed} (${percentage}%)`;
            }
          }
        }
      },
      cutout: '60%'
    }
  };
};

const criarGraficoBarras = (estatisticas) => {
  const isDark = document.documentElement.classList.contains('dark');
  const textColor = isDark ? '#f3f4f6' : '#1f2937';
  const gridColor = isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)';
  
  let labels = [];
  let data = [];
  let backgroundColor = [];
  let borderColor = [];
  let title = '';
  
  if (abaAtiva.value === 'geral') {
    labels = ['Preparos', 'Resultados', 'Place', 'WorksLightWeb'];
    data = [
      estatisticas.total_preparos,
      estatisticas.total_resultados,
      estatisticas.total_telelaudo,
      estatisticas.total_portalweb || 0
    ];
    backgroundColor = ['rgba(34, 197, 94, 0.8)', 'rgba(249, 115, 22, 0.8)', 'rgba(168, 85, 247, 0.8)', 'rgba(99, 102, 241, 0.8)'];
    borderColor = ['rgb(34, 197, 94)', 'rgb(249, 115, 22)', 'rgb(168, 85, 247)', 'rgb(99, 102, 241)'];
    title = 'Tipos de Acesso';
  } else if (abaAtiva.value === 'preparos') {
    labels = ['Preparos'];
    data = [estatisticas.total_preparos || estatisticas.total];
    backgroundColor = ['rgba(34, 197, 94, 0.8)'];
    borderColor = ['rgb(34, 197, 94)'];
    title = 'Acessos aos Preparos';
  } else if (abaAtiva.value === 'resultados') {
    labels = ['Tentativas de Login', 'Logins com Sucesso'];
    data = [estatisticas.tentativas_login, estatisticas.logins_sucesso];
    backgroundColor = ['rgba(239, 68, 68, 0.8)', 'rgba(16, 185, 129, 0.8)'];
    borderColor = ['rgb(239, 68, 68)', 'rgb(16, 185, 129)'];
    title = 'Tipo de Login';
  } else if (abaAtiva.value === 'telelaudo') {
    labels = ['Place'];
    data = [estatisticas.total_telelaudo || estatisticas.total];
    backgroundColor = ['rgba(168, 85, 247, 0.8)'];
    borderColor = ['rgb(168, 85, 247)'];
    title = 'Acessos ao Place';
  } else if (abaAtiva.value === 'portalweb') {
    labels = ['WorksLightWeb'];
    data = [estatisticas.total_portalweb || estatisticas.total];
    backgroundColor = ['rgba(99, 102, 241, 0.8)'];
    borderColor = ['rgb(99, 102, 241)'];
    title = 'Acessos ao WorksLightWeb';
  }
  
  return {
    type: 'bar',
    data: {
      labels: labels,
      datasets: [{
        label: 'Quantidade',
        data: data,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        borderWidth: 2,
        borderRadius: 8
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: {
          backgroundColor: isDark ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
          titleColor: textColor,
          bodyColor: textColor,
          borderColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          borderWidth: 1,
          padding: 12
        }
      },
      scales: {
        x: {
          grid: { display: false },
          ticks: { color: textColor, font: { size: 12, weight: '500' } },
          title: { display: true, text: title || 'Tipo', color: textColor, font: { size: 13, weight: '600' } }
        },
        y: {
          beginAtZero: true,
          grid: { color: gridColor, lineWidth: 1 },
          ticks: { color: textColor, font: { size: 12, weight: '500' }, stepSize: 1 },
          title: { display: true, text: 'Quantidade', color: textColor, font: { size: 13, weight: '600' } }
        }
      }
    }
  };
};

const criarGraficoPizza = (estatisticas) => {
  const isDark = document.documentElement.classList.contains('dark');
  const textColor = isDark ? '#f3f4f6' : '#1f2937';
  
  let labels = [];
  let data = [];
  let backgroundColor = [];
  
  if (abaAtiva.value === 'geral') {
    labels = ['Preparos', 'Resultados', 'Place', 'WorksLightWeb'];
    data = [
      estatisticas.total_preparos,
      estatisticas.total_resultados,
      estatisticas.total_telelaudo,
      estatisticas.total_portalweb || 0
    ];
    backgroundColor = [
      'rgb(34, 197, 94)',
      'rgb(249, 115, 22)',
      'rgb(168, 85, 247)',
      'rgb(99, 102, 241)'
    ];
  } else if (abaAtiva.value === 'preparos') {
    labels = ['Preparos'];
    data = [estatisticas.total_preparos || estatisticas.total];
    backgroundColor = ['rgb(34, 197, 94)'];
  } else if (abaAtiva.value === 'resultados') {
    labels = ['Tentativas de Login', 'Logins com Sucesso'];
    data = [
      estatisticas.tentativas_login,
      estatisticas.logins_sucesso
    ];
    backgroundColor = [
      'rgb(239, 68, 68)',
      'rgb(16, 185, 129)'
    ];
  } else if (abaAtiva.value === 'telelaudo') {
    labels = ['Place'];
    data = [estatisticas.total_telelaudo || estatisticas.total];
    backgroundColor = ['rgb(168, 85, 247)'];
  } else if (abaAtiva.value === 'portalweb') {
    labels = ['WorksLightWeb'];
    data = [estatisticas.total_portalweb || estatisticas.total];
    backgroundColor = ['rgb(99, 102, 241)'];
  }
  
  return {
    type: 'pie',
    data: {
      labels: labels,
      datasets: [{
        data: data,
        backgroundColor: backgroundColor,
        borderColor: isDark ? 'rgba(31, 41, 55, 1)' : 'rgba(255, 255, 255, 1)',
        borderWidth: 3,
        hoverOffset: 10
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            padding: 20,
            font: { size: 13, weight: '500' },
            color: textColor,
            usePointStyle: true
          }
        },
        tooltip: {
          backgroundColor: isDark ? 'rgba(31, 41, 55, 0.95)' : 'rgba(255, 255, 255, 0.95)',
          titleColor: textColor,
          bodyColor: textColor,
          borderColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
          borderWidth: 1,
          padding: 12,
          callbacks: {
            label: function(context) {
              const total = context.dataset.data.reduce((a, b) => a + b, 0);
              const percentage = total > 0 ? ((context.parsed / total) * 100).toFixed(1) : 0;
              return `${context.label}: ${context.parsed} (${percentage}%)`;
            }
          }
        }
      }
    }
  };
};

const carregarGraficos = async () => {
  try {
    const params = new URLSearchParams();
    
    // Sempre adicionar filtros de data se estiverem preenchidos
    if (filtrosGrafico.value.data_inicio) {
      params.append('data_inicio', filtrosGrafico.value.data_inicio);
    }
    if (filtrosGrafico.value.data_fim) {
      params.append('data_fim', filtrosGrafico.value.data_fim);
    }
    
    // Aplicar filtro de tipo_acesso baseado na aba ativa
    if (abaAtiva.value === 'telelaudo') {
      params.append('tipo_acesso', 'telelaudo');
    } else if (abaAtiva.value === 'preparos') {
      params.append('tipo_acesso', 'preparos');
    } else if (abaAtiva.value === 'resultados') {
      params.append('tipo_acesso', 'resultados');
    } else if (filtrosGrafico.value.tipo_acesso) {
      // Na aba geral, usar o filtro selecionado
      params.append('tipo_acesso', filtrosGrafico.value.tipo_acesso);
    }
    
    const queryString = params.toString() ? `?${params.toString()}` : '';
    
    // Buscar dados diários para linha e mensais para estatísticas
    const [responseDadosDiarios, responseEstatisticas] = await Promise.all([
      apiClient.get(`/api/v1/portal-acessos/admin/estatisticas-diarias${queryString}`),
      apiClient.get(queryString ? `/api/v1/portal-acessos/admin/total${queryString}` : '/api/v1/portal-acessos/admin/total/')
    ]);
    
    const dadosDiarios = responseDadosDiarios.data;
    const estatisticas = responseEstatisticas.data;

    // Destruir gráficos anteriores
    if (chartInstanceLinha) {
      chartInstanceLinha.destroy();
      chartInstanceLinha = null;
    }
    if (chartInstanceRosquinha) {
      chartInstanceRosquinha.destroy();
      chartInstanceRosquinha = null;
    }
    if (chartInstanceBarras) {
      chartInstanceBarras.destroy();
      chartInstanceBarras = null;
    }
    if (chartInstancePizza) {
      chartInstancePizza.destroy();
      chartInstancePizza = null;
    }

    // Aguardar renderização
    await nextTick();
    await new Promise(resolve => setTimeout(resolve, 200));
    
    // Criar gráfico de linha
    if (chartLinha.value) {
      chartLinha.value.width = chartLinha.value.offsetWidth;
      chartLinha.value.height = chartLinha.value.offsetHeight;
      
      if (!dadosDiarios || dadosDiarios.length === 0) {
        chartInstanceLinha = new Chart(chartLinha.value, {
          type: 'line',
          data: { labels: [], datasets: [] },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: { 
              legend: { position: 'top' },
              title: {
                display: true,
                text: 'Nenhum dado encontrado',
                color: document.documentElement.classList.contains('dark') ? '#f3f4f6' : '#1f2937'
              }
            }
          }
        });
      } else {
        const configLinha = criarGraficoLinha(dadosDiarios);
        chartInstanceLinha = new Chart(chartLinha.value, configLinha);
      }
    }
    
    // Criar gráfico rosquinha
    if (chartRosquinha.value) {
      chartRosquinha.value.width = chartRosquinha.value.offsetWidth;
      chartRosquinha.value.height = chartRosquinha.value.offsetHeight;
      const configRosquinha = criarGraficoRosquinha(estatisticas);
      chartInstanceRosquinha = new Chart(chartRosquinha.value, configRosquinha);
    }
    
    // Criar gráfico de barras
    if (chartBarras.value) {
      chartBarras.value.width = chartBarras.value.offsetWidth;
      chartBarras.value.height = chartBarras.value.offsetHeight;
      const configBarras = criarGraficoBarras(estatisticas);
      chartInstanceBarras = new Chart(chartBarras.value, configBarras);
    }
    
    // Criar gráfico pizza
    if (chartPizza.value) {
      chartPizza.value.width = chartPizza.value.offsetWidth;
      chartPizza.value.height = chartPizza.value.offsetHeight;
      const configPizza = criarGraficoPizza(estatisticas);
      chartInstancePizza = new Chart(chartPizza.value, configPizza);
    }
  } catch (err) {
    console.error('Erro ao carregar gráficos:', err);
  }
};

// Watcher para recriar gráficos quando mudar para aba de gráficos
watch(tipoGrafico, async (newVal) => {
  if (mostrarGraficos.value && newVal === 'graficos') {
    await nextTick();
    await carregarGraficos();
  } else if (newVal === 'relatorios') {
    // Carregar unidades quando abrir aba de relatórios
    await carregarUnidadesRelatorio();
  }
});

// Watcher para recarregar acessos, estatísticas e gráficos quando a aba mudar
watch(abaAtiva, async () => {
  pagination.value.current_page = 1;
  filtros.value.unidade = ''; // Limpar filtro de unidade ao mudar de aba
  if (abaAtiva.value === 'telelaudo' || abaAtiva.value === 'portalweb') {
    await carregarUnidades();
  } else {
    unidadesDisponiveis.value = [];
  }
  await Promise.all([carregarAcessos(), carregarEstatisticas()]);
  if (mostrarGraficos.value) {
    await carregarGraficos();
  }
});

// Watcher para aplicar filtro automaticamente quando a unidade mudar
watch(() => filtros.value.unidade, async () => {
  if (abaAtiva.value === 'telelaudo' || abaAtiva.value === 'portalweb') {
    pagination.value.current_page = 1;
    await Promise.all([carregarAcessos(), carregarEstatisticas()]);
    if (mostrarGraficos.value) {
      await carregarGraficos();
    }
  }
});

// Watcher para detectar mudanças nos filtros de relatório
watch(() => [
  filtrosRelatorio.value.data_inicio,
  filtrosRelatorio.value.data_fim,
  filtrosRelatorio.value.tipo_relatorio,
  filtrosRelatorio.value.unidade_place,
  filtrosRelatorio.value.unidade_workslightweb,
  filtrosRelatorio.value.orientacao
], () => {
  // Se já existem dados de relatório gerados, marcar que os filtros foram alterados
  if (dadosRelatorio.value.length > 0) {
    filtrosAlterados.value = true;
    mostrarVisualizacao.value = false;
  }
}, { deep: true });

const aplicarFiltros = async () => {
  pagination.value.current_page = 1; // Resetar para primeira página ao aplicar filtros
  await Promise.all([carregarAcessos(), carregarEstatisticas()]);
  if (mostrarGraficos.value) {
    await carregarGraficos();
  }
};

const irParaPagina = async (page) => {
  // Garantir que page é um número válido
  if (typeof page !== 'number' || page < 1 || page > pagination.value.total_pages) {
    return;
  }
  pagination.value.current_page = page;
  await carregarAcessos();
  // Scroll para o topo da tabela
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const paginasVisiveis = computed(() => {
  const total = pagination.value.total_pages;
  const current = pagination.value.current_page;
  const pages = [];
  
  if (total <= 7) {
    // Mostrar todas as páginas se houver 7 ou menos
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    // Sempre mostrar primeira página
    pages.push(1);
    
    if (current <= 3) {
      // Perto do início
      for (let i = 2; i <= 4; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(total);
    } else if (current >= total - 2) {
      // Perto do fim
      pages.push('...');
      for (let i = total - 3; i <= total; i++) {
        pages.push(i);
      }
    } else {
      // No meio
      pages.push('...');
      for (let i = current - 1; i <= current + 1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(total);
    }
  }
  
  return pages;
});

const aplicarFiltrosGrafico = async () => {
  if (mostrarGraficos.value) {
    await carregarGraficos();
  }
};

const toggleGraficos = async () => {
  mostrarGraficos.value = !mostrarGraficos.value;
  if (mostrarGraficos.value && tipoGrafico.value === 'graficos') {
    await nextTick();
    await carregarGraficos();
  } else {
    // Destruir todos os gráficos
    if (chartInstanceLinha) {
      chartInstanceLinha.destroy();
      chartInstanceLinha = null;
    }
    if (chartInstanceRosquinha) {
      chartInstanceRosquinha.destroy();
      chartInstanceRosquinha = null;
    }
    if (chartInstanceBarras) {
      chartInstanceBarras.destroy();
      chartInstanceBarras = null;
    }
    if (chartInstancePizza) {
      chartInstancePizza.destroy();
      chartInstancePizza = null;
    }
  }
};

const gerarRelatorio = async () => {
  gerandoRelatorio.value = true;
  dadosRelatorio.value = [];
  colunasRelatorio.value = [];
  mostrarVisualizacao.value = false;
  filtrosAlterados.value = false;
  
  try {
    const params = new URLSearchParams();
    if (filtrosRelatorio.value.data_inicio) params.append('data_inicio', filtrosRelatorio.value.data_inicio);
    if (filtrosRelatorio.value.data_fim) params.append('data_fim', filtrosRelatorio.value.data_fim);
    params.append('tipo_relatorio', filtrosRelatorio.value.tipo_relatorio);
    
    if (filtrosRelatorio.value.unidade_place) {
      params.append('unidade', filtrosRelatorio.value.unidade_place);
      params.append('tipo_acesso', 'telelaudo');
    }
    if (filtrosRelatorio.value.unidade_workslightweb) {
      params.append('unidade', filtrosRelatorio.value.unidade_workslightweb);
      params.append('tipo_acesso', 'portalweb');
    }
    
    const response = await apiClient.get(`/api/v1/portal-acessos/admin/relatorio/?${params.toString()}`);
    dadosRelatorio.value = response.data.dados || [];
    colunasRelatorio.value = response.data.colunas || [];
    totalGeralRelatorio.value = response.data.total_geral || null;
    totalPorUnidadeRelatorio.value = response.data.total_por_unidade || [];
    mostrarVisualizacao.value = true;
    filtrosAlterados.value = false; // Resetar flag após gerar com sucesso
  } catch (err) {
    console.error('Erro ao gerar relatório:', err);
    alert('Erro ao gerar relatório. Por favor, tente novamente.');
  } finally {
    gerandoRelatorio.value = false;
  }
};

const downloadCSV = () => {
  if (dadosRelatorio.value.length === 0) {
    alert('Não há dados para exportar. Gere o relatório primeiro.');
    return;
  }
  
  // Criar CSV
  const headers = colunasRelatorio.value.join(',');
  const rows = dadosRelatorio.value.map(linha => {
    return colunasRelatorio.value.map(coluna => {
      const valor = linha[coluna] || '-';
      // Escapar vírgulas e aspas no CSV
      if (String(valor).includes(',') || String(valor).includes('"')) {
        return `"${String(valor).replace(/"/g, '""')}"`;
      }
      return valor;
    }).join(',');
  });
  
  const csvContent = [headers, ...rows].join('\n');
  const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `Relatorio_${filtrosRelatorio.value.tipo_relatorio}_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const gerarPDFRelatorio = async () => {
  if (dadosRelatorio.value.length === 0) {
    alert('Não há dados para gerar o PDF. Gere o relatório primeiro.');
    return;
  }
  
  try {
    // Usar orientação selecionada
    const orientacao = filtrosRelatorio.value.orientacao || 'p';
    const doc = new jsPDF(orientacao, 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 25;
    const marginTop = 30;
    const marginBottom = 60;
    const contentWidth = pageWidth - (margin * 2);
    
    // Carregar logos
    let headerLogoImg = null;
    let footerLogoImg = null;
    
    try {
      headerLogoImg = new Image();
      // Tentar diferentes caminhos para a logo
      headerLogoImg.src = '/ccdlogo.png';
      await new Promise((resolve, reject) => {
        headerLogoImg.onload = resolve;
        headerLogoImg.onerror = () => {
          // Tentar caminho alternativo
          headerLogoImg.src = '/static/img/logo.png';
          headerLogoImg.onload = resolve;
          headerLogoImg.onerror = reject;
        };
      });
    } catch (err) {
      console.error('Erro ao carregar logo do cabeçalho:', err);
    }
    
    try {
      footerLogoImg = new Image();
      // Tentar carregar logo do rodapé - pode não existir, então não é crítico
      footerLogoImg.src = '/logo_ccdti.png';
      await new Promise((resolve) => {
        footerLogoImg.onload = resolve;
        footerLogoImg.onerror = () => {
          // Se não encontrar, usar logo do cabeçalho como fallback
          footerLogoImg = headerLogoImg;
          resolve();
        };
      });
    } catch (err) {
      console.error('Erro ao carregar logo do rodapé:', err);
      // Usar logo do cabeçalho como fallback
      footerLogoImg = headerLogoImg;
    }
    
    // Função para adicionar cabeçalho
    const addHeader = (pageNum, isFirstPage = false) => {
      if (headerLogoImg) {
        const logoWidth = 70;
        const logoHeight = (headerLogoImg.height / headerLogoImg.width) * logoWidth;
        const logoX = (pageWidth - logoWidth) / 2;
        doc.addImage(headerLogoImg, 'PNG', logoX, marginTop - 5, logoWidth, logoHeight);
      }
      
      if (isFirstPage) {
        const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
        let yPos = marginTop - 5 + logoHeight + 8;
        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.setFont(undefined, 'italic');
        doc.text('Relatório de Acessos ao Portal', margin, yPos, { align: 'left' });
        yPos += 8;
        
        doc.setDrawColor(0, 91, 170);
        doc.setLineWidth(0.5);
        doc.line(margin, yPos, pageWidth - margin, yPos);
      } else {
        const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
        const separatorY = marginTop - 5 + logoHeight + 8;
        doc.setDrawColor(0, 91, 170);
        doc.setLineWidth(0.5);
        doc.line(margin, separatorY, pageWidth - margin, separatorY);
      }
    };
    
    // Função para adicionar rodapé
    const addFooter = (pageNum, totalPages) => {
      const footerContentHeight = 8 + 10 + 4 + 4 + 6;
      const footerY = pageHeight - footerContentHeight - 10;
      
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.3);
      doc.line(margin, footerY - 8, pageWidth - margin, footerY - 8);
      
      if (footerLogoImg) {
        const footerLogoWidth = 25;
        const footerLogoHeight = (footerLogoImg.height / footerLogoImg.width) * footerLogoWidth;
        const footerLogoX = (pageWidth - footerLogoWidth) / 2;
        doc.addImage(footerLogoImg, 'PNG', footerLogoX, footerY - 3, footerLogoWidth, footerLogoHeight);
      }
      
      doc.setFontSize(8);
      doc.setTextColor(100, 100, 100);
      doc.text(`Página ${pageNum} de ${totalPages}`, pageWidth / 2, footerY + 12, { align: 'center' });
    };
    
    let currentPage = 1;
    addHeader(currentPage, true);
    
    const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
    let yPosition = marginTop - 5 + logoHeight + 8 + 8 + 8 + 10;
    
    // Título do relatório
    doc.setFontSize(14);
    doc.setTextColor(0, 91, 170);
    doc.setFont(undefined, 'bold');
    const tituloRelatorio = getTituloRelatorio();
    const tituloLines = doc.splitTextToSize(tituloRelatorio, contentWidth);
    tituloLines.forEach((line) => {
      if (yPosition + 8 > pageHeight - marginBottom) {
        doc.addPage();
        currentPage++;
        addHeader(currentPage, false);
        const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
        yPosition = marginTop - 5 + logoHeight + 8 + 10;
      }
      doc.text(line, pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 8;
    });
    yPosition += 6;
    
    // Informações do período
    if (filtrosRelatorio.value.data_inicio || filtrosRelatorio.value.data_fim) {
      doc.setFontSize(10);
      doc.setTextColor(100, 100, 100);
      doc.setFont(undefined, 'normal');
      const periodo = `Período: ${filtrosRelatorio.value.data_inicio || 'Início'} a ${filtrosRelatorio.value.data_fim || 'Fim'}`;
      doc.text(periodo, pageWidth / 2, yPosition, { align: 'center' });
      yPosition += 8;
    }
    yPosition += 6;
    
    // Tabela
    if (colunasRelatorio.value.length > 0 && dadosRelatorio.value.length > 0) {
      // Definir larguras proporcionais para cada tipo de coluna
      const getColumnWidth = (coluna, totalCols) => {
        const colunaLower = coluna.toLowerCase();
        if (colunaLower.includes('data') || colunaLower.includes('hora')) {
          return contentWidth * 0.20; // 20% para Data/Hora
        } else if (colunaLower.includes('unidade')) {
          return contentWidth * 0.30; // 30% para Unidade
        } else if (colunaLower.includes('quantidade')) {
          return contentWidth * 0.15; // 15% para Quantidade
        } else if (colunaLower.includes('tipo')) {
          return contentWidth * 0.20; // 20% para Tipo de Acesso
        } else if (colunaLower.includes('login')) {
          return contentWidth * 0.25; // 25% para Login
        } else if (colunaLower.includes('status')) {
          return contentWidth * 0.20; // 20% para Status
        } else if (colunaLower.includes('ip')) {
          return contentWidth * 0.15; // 15% para IP
        } else {
          // Distribuir igualmente o restante
          return contentWidth / totalCols;
        }
      };
      
      // Calcular posições X de cada coluna
      const colPositions = [];
      let currentX = margin + 3;
      colunasRelatorio.value.forEach((coluna) => {
        const colWidth = getColumnWidth(coluna, colunasRelatorio.value.length);
        const textWidth = colWidth - 6; // Largura disponível para texto (descontando padding)
        colPositions.push({
          x: currentX,
          width: textWidth,
          name: coluna
        });
        currentX += colWidth;
      });
      
      const rowHeight = 8;
      const headerHeight = 9;
      
      // Função para adicionar cabeçalho da tabela
      const addTableHeader = (y) => {
        const headerY = y;
        doc.setFillColor(0, 91, 170);
        doc.roundedRect(margin, headerY, contentWidth, headerHeight, 2, 2, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFont(undefined, 'bold');
        doc.setFontSize(9);
        
        // Centralizar verticalmente o texto no cabeçalho
        const textY = headerY + (headerHeight / 2) + 2;
        colPositions.forEach((col) => {
          const text = doc.splitTextToSize(col.name, col.width);
          doc.text(text[0], col.x, textY, { maxWidth: col.width, align: 'left' });
        });
        
        doc.setTextColor(0, 0, 0);
        doc.setFont(undefined, 'normal');
        // Retornar a posição Y abaixo do cabeçalho
        return headerY + headerHeight + 2;
      };
      
      // Adicionar cabeçalho inicial
      yPosition = addTableHeader(yPosition);
      
      // Dados da tabela
      doc.setFontSize(8);
      dadosRelatorio.value.forEach((linha, index) => {
        // Verificar se precisa de nova página
        if (yPosition + rowHeight > pageHeight - marginBottom) {
          doc.addPage();
          currentPage++;
          addHeader(currentPage, false);
          const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
          yPosition = marginTop - 5 + logoHeight + 8 + 10;
          yPosition = addTableHeader(yPosition);
        }
        
        const rowY = yPosition;
        
        // Alternar cor de fundo para melhor legibilidade
        if (index % 2 === 0) {
          doc.setFillColor(245, 245, 245);
          doc.roundedRect(margin, rowY, contentWidth, rowHeight, 1, 1, 'F');
        }
        
        // Desenhar bordas verticais das células
        doc.setDrawColor(220, 220, 220);
        doc.setLineWidth(0.1);
        colPositions.forEach((col, idx) => {
          if (idx < colPositions.length - 1) {
            const borderX = col.x + col.width + 3;
            doc.line(borderX, rowY, borderX, rowY + rowHeight);
          }
        });
        
        // Adicionar dados de cada coluna - centralizar verticalmente
        const textY = rowY + (rowHeight / 2) + 2;
        colPositions.forEach((col) => {
          const valor = linha[col.name] || '-';
          const text = doc.splitTextToSize(String(valor), col.width);
          doc.text(text[0], col.x, textY, { maxWidth: col.width, align: 'left' });
        });
        
        yPosition += rowHeight;
      });
    }
    
    // Exibir Total Geral e Total por Unidade no final (apenas para relatório geral)
    if (filtrosRelatorio.value.tipo_relatorio === 'geral') {
      // Verificar se precisa de nova página para os totais
      if (yPosition + 40 > pageHeight - marginBottom) {
        doc.addPage();
        currentPage++;
        addHeader(currentPage, false);
        const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
        yPosition = marginTop - 5 + logoHeight + 8 + 10;
      } else {
        yPosition += 10; // Espaçamento antes da seção
      }
      
      // Total Geral (lado direito) e Total por Unidade (lado esquerdo) na mesma linha
      const linhaY = yPosition;
      
      // Total Geral - lado direito
      if (totalGeralRelatorio.value !== null) {
        doc.setFontSize(12);
        doc.setTextColor(0, 91, 170);
        doc.setFont(undefined, 'bold');
        doc.text(`Total Geral de Acessos: ${totalGeralRelatorio.value}`, pageWidth - margin, linhaY, { align: 'right' });
      }
      
      // Total por Unidade - lado esquerdo
      if (totalPorUnidadeRelatorio.value && totalPorUnidadeRelatorio.value.length > 0) {
        // Título da seção
        doc.setFontSize(12);
        doc.setTextColor(0, 91, 170);
        doc.setFont(undefined, 'bold');
        doc.text('Total por Unidade', margin, linhaY, { align: 'left' });
      }
      
      // Avançar para próxima linha apenas se houver total por unidade
      if (totalPorUnidadeRelatorio.value && totalPorUnidadeRelatorio.value.length > 0) {
        yPosition += 8;
        
        doc.setFontSize(9);
        doc.setFont(undefined, 'normal');
        doc.setTextColor(60, 60, 60);
        
        // Criar uma tabela simples para os totais por unidade
        const totalTableWidth = contentWidth * 0.6; // 60% da largura
        const totalTableX = margin;
        const unitColWidth = totalTableWidth * 0.7;
        
        // Cabeçalho da tabela de totais
        doc.setFillColor(240, 240, 240);
        doc.roundedRect(totalTableX, yPosition - 5, totalTableWidth, 6, 1, 1, 'F');
        doc.setFont(undefined, 'bold');
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        doc.text('Unidade', totalTableX + 3, yPosition, { align: 'left' });
        doc.text('Quantidade', totalTableX + unitColWidth + 3, yPosition, { align: 'left' });
        yPosition += 7;
        
        // Dados da tabela de totais
        doc.setFont(undefined, 'normal');
        doc.setFontSize(8);
        totalPorUnidadeRelatorio.value.forEach((item, idx) => {
          // Verificar se precisa de nova página
          if (yPosition + 6 > pageHeight - marginBottom) {
            doc.addPage();
            currentPage++;
            addHeader(currentPage, false);
            const logoHeight = headerLogoImg ? (headerLogoImg.height / headerLogoImg.width) * 70 : 0;
            yPosition = marginTop - 5 + logoHeight + 8 + 10;
            
            // Recriar cabeçalho da tabela de totais
            doc.setFillColor(240, 240, 240);
            doc.roundedRect(totalTableX, yPosition - 5, totalTableWidth, 6, 1, 1, 'F');
            doc.setFont(undefined, 'bold');
            doc.setFontSize(9);
            doc.setTextColor(0, 0, 0);
            doc.text('Unidade', totalTableX + 3, yPosition, { align: 'left' });
            doc.text('Quantidade', totalTableX + unitColWidth + 3, yPosition, { align: 'left' });
            yPosition += 7;
            doc.setFont(undefined, 'normal');
            doc.setFontSize(8);
          }
          
          // Alternar cor de fundo
          if (idx % 2 === 0) {
            doc.setFillColor(250, 250, 250);
            doc.roundedRect(totalTableX, yPosition - 4, totalTableWidth, 5, 0.5, 0.5, 'F');
          }
          
          doc.setTextColor(0, 0, 0);
          doc.text(item.unidade || '-', totalTableX + 3, yPosition, { maxWidth: unitColWidth - 6, align: 'left' });
          doc.text(String(item.quantidade), totalTableX + unitColWidth + 3, yPosition, { align: 'left' });
          yPosition += 5;
        });
      }
    }
    
    // Adicionar rodapé em todas as páginas
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      addFooter(i, totalPages);
    }
    
    // Salvar PDF
    const nomeArquivo = `Relatorio_${filtrosRelatorio.value.tipo_relatorio}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(nomeArquivo);
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
    alert('Erro ao gerar PDF. Por favor, tente novamente.');
  }
};

const getTituloRelatorio = () => {
  const tipos = {
    'geral': 'Relatório Geral de Acessos',
    'por_tipo_acesso': 'Relatório por Tipo de Acesso',
    'por_tentativa': 'Relatório por Tentativas de Login',
    'por_login_sucesso': 'Relatório por Logins com Sucesso',
    'por_place': 'Relatório de Acessos ao Place',
    'por_unidade_place': 'Relatório por Unidade (Place)',
    'por_workslightweb': 'Relatório de Acessos ao WorksLightWeb',
    'por_preparos': 'Relatório de Acessos aos Preparos',
    'por_resultados': 'Relatório de Acessos aos Resultados'
  };
  return tipos[filtrosRelatorio.value.tipo_relatorio] || 'Relatório de Acessos';
};

onMounted(async () => {
  if (temPermissao.value) {
    if (abaAtiva.value === 'telelaudo' || abaAtiva.value === 'portalweb') {
      await carregarUnidades();
    }
    await Promise.all([carregarAcessos(), carregarEstatisticas()]);
  }
});
</script>
